import { api } from '@/core/lib/api-client';

export interface DiningOutlet {
  id: string;
  name: string;
  type: 'restaurant' | 'bar' | 'cafe' | 'room-service' | 'poolside';
  cuisine: string;
  capacity: number;
  openTime: string;
  closeTime: string;
  isActive: boolean;
  imageUrl?: string;
}

export interface DiningReservation {
  id: string;
  outletId: string;
  outletName: string;
  guestId: string;
  guestName: string;
  partySize: number;
  date: string;
  time: string;
  status: 'confirmed' | 'pending' | 'cancelled' | 'completed' | 'no-show';
  specialRequests?: string;
  createdAt: string;
}

export interface DiningOutletListResponse {
  data: DiningOutlet[];
  meta: { total: number };
}

export interface DiningReservationListResponse {
  data: DiningReservation[];
  meta: { total: number; page: number; limit: number };
}

export interface CreateDiningReservationDto {
  outletId: string;
  guestId: string;
  partySize: number;
  date: string;
  time: string;
  specialRequests?: string;
}

export interface DiningReservationMutationResponse {
  data: DiningReservation;
  message: string;
}

export interface DiningReservationListParams {
  page?: number;
  limit?: number;
  outletId?: string;
  status?: string;
  date?: string;
}

export interface DiningDataResponse {
  data: Record<string, unknown>;
}

export class DiningService {
  private static OUTLETS = '/hotel/dining/outlets';
  private static RESERVATIONS = '/hotel/dining/reservations';
  private static DATA = '/hotel/dining/data';

  static async getData(): Promise<DiningDataResponse> {
    return api.get<DiningDataResponse>(this.DATA);
  }

  static async listOutlets(): Promise<DiningOutletListResponse> {
    return api.get<DiningOutletListResponse>(this.OUTLETS);
  }

  static async listReservations(
    params?: DiningReservationListParams,
  ): Promise<DiningReservationListResponse> {
    return api.get<DiningReservationListResponse>(this.RESERVATIONS, {
      params: params as Record<string, string | number | boolean | undefined>,
    });
  }

  static async createReservation(
    dto: CreateDiningReservationDto,
  ): Promise<DiningReservationMutationResponse> {
    return api.post<DiningReservationMutationResponse>(this.RESERVATIONS, dto);
  }
}
